import { Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-detail-section',
    templateUrl: './detail-section.component.html',
    styleUrls: ['./detail-section.component.scss'],
    standalone: false,
})
export class DetailSectionComponent {
    @Input()
    public title?: string;

    @Input()
    public highlight?: boolean;

    @Input()
    public isList?: boolean;

    // Only in list-view, spans all columns in the grid.
    @Input()
    @HostBinding('class.full-width')
    public fullWidth = false;
}
